import underscore from 'underscore';

window._ = underscore;
